import { render, staticRenderFns } from "./QrIcon.vue?vue&type=template&id=dfaddb12&scoped=true"
import script from "./QrIcon.vue?vue&type=script&lang=js"
export * from "./QrIcon.vue?vue&type=script&lang=js"
import style0 from "./QrIcon.vue?vue&type=style&index=0&id=dfaddb12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfaddb12",
  null
  
)

export default component.exports